import React from 'react';

import { Container } from './Legal.styled';

import { Logo } from './Logo';
import { Privacy } from './Privacy';

export const Legal = () => {
  return (
    <Container>
      <Logo />
      <Privacy />
    </Container>
  );
};
